import { render, staticRenderFns } from "./LotteryMyPrizes.vue?vue&type=template&id=23e08cf5&scoped=true&"
import script from "./LotteryMyPrizes.vue?vue&type=script&lang=js&"
export * from "./LotteryMyPrizes.vue?vue&type=script&lang=js&"
import style0 from "./LotteryMyPrizes.vue?vue&type=style&index=0&id=23e08cf5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e08cf5",
  null
  
)

export default component.exports